import { ApolloClient, NormalizedCacheObject } from '@apollo/client';
import gql from 'graphql-tag';
import { UpsertNotePayload, UpsertNoteInput } from '../gql-types.generated';

// eslint-disable-next-line @typescript-eslint/naming-convention
const MUTATION_UPSERT_PARTNER_NOTE = gql`
    mutation upsertPartnerNote($input: UpsertNoteInput!){
        upsertPartnerNote(input: $input){
            message
            errors {
                code
                message
            }
            result
        }
    }
`;

export const mutationUpsertTradingPartnerNote = async (
    client: ApolloClient<NormalizedCacheObject>,
    args: {
        upsertNoteData: UpsertNoteInput
    }
): Promise<UpsertNotePayload | undefined> => {
    const { parentId, id, header, note } = args.upsertNoteData;
    const { data, errors } = await client.mutate<{ upsertPartnerNote: UpsertNotePayload }>({
        variables: {
            input: {
                parentId,
                id,
                header,
                note
            }
        },
        mutation: MUTATION_UPSERT_PARTNER_NOTE
    });
    if (errors && errors.length > 0) {
        errors.forEach(error => {
            // Log error details in the console
            console.error(error);
        });
        // Friendly error to active user
        throw new Error('An error has occurred during the partner note save.');
    }
    if (data && data.upsertPartnerNote) {
        return data.upsertPartnerNote;
    }
    return undefined;
};